module.exports = __webpack_public_path__ + "img/train-10.8de83994.jpg";